<template>
  <div class="site-footer">
    <div class="footer-main">
      <div class="container">
        <div class="footer-grid">
          <!-- 品牌列 -->
          <div class="f-col f-brand">
            <img src="@/assets/images/logo.png" width="140" alt="Taoify" class="f-logo" />
            <p class="f-company">{{ $t('香港星橋國際貿易有限公司') }}</p>
            <div class="f-social">
              <a href="https://www.facebook.com/alibabaagent" target="_blank" rel="noopener" aria-label="Facebook">
                <v-icon size="20">mdi-facebook</v-icon>
              </a>
              <v-menu offset-y top>
                <template v-slot:activator="{ on, attrs }">
                  <a v-bind="attrs" v-on="on" href="javascript:void(0)" aria-label="WeChat">
                    <v-icon size="20">mdi-wechat</v-icon>
                  </a>
                </template>
                <v-card class="f-qrcode" flat>
                  <v-img src="@/assets/images/recruit/erweima.png" width="180" height="180"></v-img>
                </v-card>
              </v-menu>
              <a href="https://twitter.com/mkMfnDdfNeAuPso" target="_blank" rel="noopener" aria-label="Twitter">
                <v-icon size="20">mdi-twitter</v-icon>
              </a>
            </div>
          </div>

          <!-- 产品列 -->
          <div class="f-col">
            <h4 class="f-title">{{ $t('产品功能') }}</h4>
            <ul class="f-links">
              <li><router-link to="/feature">{{ $t('功能介绍') }}</router-link></li>
              <li><router-link to="/template-index">{{ $t('模版市场') }}</router-link></li>
              <li><router-link to="/pricing">{{ $t('价格方案') }}</router-link></li>
              <li><router-link to="/case">{{ $t('客户案例') }}</router-link></li>
            </ul>
          </div>

          <!-- 支持列 -->
          <div class="f-col">
            <h4 class="f-title">{{ $t('支持帮助') }}</h4>
            <ul class="f-links">
              <li><router-link to="/question">{{ $t('帮助中心') }}</router-link></li>
              <li><router-link to="/about-us">{{ $t('关于我们') }}</router-link></li>
              <li><router-link to="/recruit">{{ $t('加入我们') }}</router-link></li>
            </ul>
          </div>

          <!-- 法律条款列 -->
          <div class="f-col">
            <h4 class="f-title">{{ $t('法律条款') }}</h4>
            <ul class="f-links">
              <li><router-link to="/terms-service">{{ $t('服务条款') }}</router-link></li>
              <li><router-link to="/user-agreement">{{ $t('用户使用协议') }}</router-link></li>
              <li><router-link to="/consumer-agreement">{{ $t('消费协议') }}</router-link></li>
              <li><router-link to="/privacy-policy">{{ $t('隐私政策') }}</router-link></li>
            </ul>
          </div>

          <!-- 联系列 -->
          <div class="f-col">
            <h4 class="f-title">{{ $t('联系我们') }}</h4>
            <ul class="f-contact">
              <li>
                <v-icon size="16" class="f-contact-ic">mdi-phone-outline</v-icon>
                <span>15188358607</span>
              </li>
              <li>
                <v-icon size="16" class="f-contact-ic">mdi-email-outline</v-icon>
                <span>liutaotao@taocarts.com</span>
              </li>
              <li>
                <v-icon size="16" class="f-contact-ic">mdi-wechat</v-icon>
                <span>{{ $t('微信号') }}：zzsist666</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权条 -->
    <div class="footer-bottom">
      <div class="container">
        <p class="f-copy">
          © {{ year }} Taoify · 香港星橋國際貿易有限公司 · {{ $t('版权所有') }}
        </p>
      </div>
    </div>

    <!-- 回到顶部 -->
    <button v-show="showBackTop" class="footer-backtop" @click="scrollToTop" :title="$t('回到顶部')">
      <span class="footer-backtop__arrow"></span>
    </button>

    <!-- Cookie 提示 -->
    <v-snackbar v-model="showCookieNotice" :timeout="-1" color="rgba(15,52,96,.92)" bottom class="cookie-notice">
      <v-row align="center" no-gutters>
        <v-col>
          {{ $t("我们使用cookie来确保我们为您提供最佳的网站体验。如果您想更改自己的偏好，可以") }}
          <router-link to="/privacy-policy" class="white--text text-decoration-underline">
            {{ $t("按照此处的说明进行") }}
          </router-link>。
        </v-col>
        <v-col cols="auto" class="ml-2">
          <v-btn light color="white" small @click="acceptCookies">
            {{ $t('接受') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      showCookieNotice: false,
      showBackTop: false,
      year: new Date().getFullYear(),
    };
  },
  mounted() {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      this.showCookieNotice = true;
    }
    window.addEventListener('scroll', this.onPageScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onPageScroll);
  },
  methods: {
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true');
      this.showCookieNotice = false;
      if (typeof gtag === 'function') {
        gtag('consent', 'update', {
          'ad_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'analytics_storage': 'granted'
        });
      }
    },
    onPageScroll() {
      this.showBackTop = window.pageYOffset > 400;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  }
};
</script>

<style lang="scss" scoped>
.site-footer {
  margin-top: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-main {
  background: #FAFBFD;
  border-top: 1px solid #EEF1F5;
  padding: 48px 0 36px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr 1.2fr;
  gap: 32px;
}

.f-logo {
  margin-bottom: 14px;
}

.f-desc {
  font-size: 13px;
  line-height: 1.7;
  color: #7A8499;
  margin-bottom: 16px;
}

.f-company {
  font-size: 13px;
  color: #7A8499;
  margin: 0 0 16px;
}

.f-social {
  display: flex;
  gap: 10px;

  a {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #E9EDF3;
    color: #7331FF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &:hover {
      background: #7331FF;
      color: #fff;
      border-color: #7331FF;
    }
  }
}

.f-title {
  font-size: 14px;
  font-weight: 700;
  color: #242939;
  margin: 0 0 14px;
}

.f-links, .f-contact {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 9px;
  }

  a {
    font-size: 13px;
    color: #7A8499;
    text-decoration: none;
    transition: color 0.15s;

    &:hover {
      color: #7331FF;
    }
  }
}

.f-contact {
  li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #7A8499;
  }

  .f-contact-ic {
    color: #7331FF;
  }
}

.f-qrcode {
  padding: 10px;
  border-radius: 12px;
}

.footer-bottom {
  background: #0F3460;
  padding: 14px 0;

  .f-copy {
    color: rgba(255, 255, 255, 0.75);
    font-size: 12px;
    text-align: center;
    margin: 0;
  }
}

.footer-backtop {
  position: fixed;
  right: 20px;
  bottom: 32px;
  z-index: 999;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #7331FF;
  box-shadow: 0 4px 16px rgba(115, 49, 255, 0.35);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;

  &:active { transform: scale(0.92); }
}

.footer-backtop__arrow {
  display: block;
  width: 12px;
  height: 12px;
  border-left: 2px solid #fff;
  border-top: 2px solid #fff;
  transform: rotate(45deg) translate(2px, 2px);
}

::v-deep .cookie-notice {
  .v-snack__wrapper {
    min-width: 100vw;
    max-width: 100vw;
    margin: 0;
    border-radius: 0;
  }
}

@media (max-width: 960px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
  .f-brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 560px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }
}
</style>
